import { useEffect, useRef, useState } from "react";
// css comes in hw_master css
import SubjBoxProps from "./Published_Subj_Box/SubjBoxProps";
import PublishAccessBoxProps from "../Published/published_access_box/PublishAccessBoxProps";
import SchedAssePropsBox from "../SChedule/Schedule_Assess_box/SchedAssePropsBox";
import ReviewAssePropsBox from "../../onreview/OnReview_Assessment_Box/ReviewAssePropsBox";
import CompletAssepropsBox from "../../Completed/complet_Assessment_Box/CompletAssepropsBox";
// import FilterBox from "../../On_going/Published_Assessment/Filter_Box/FilterBox";
import FilterBox from "../../../../Homework/pages/On_going/Published_Assessment/Filter_Box/FilterBox";
import { Popup } from "semantic-ui-react";
import DraftAssessPropsBox from "../Draft/Draft_Assess_Box/DraftAssessPropsBox";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import AssessmentImage from "./../../../../images/Assessment_Process_Flow.png";
import AssessmentTypePopUP from "./AssessmentTypePopUP";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PublishedAssessment = ({ leftSidebarSize }) => {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const [openImg, setOpenImg] = useState(false);

  const state = useLocation();

  useEffect(() => {
    var status = localStorage.getItem("assessmentStatus");
    if (state === "fromAssessment") {
      setActiveHeader("Scheduled");
    }
    if (status === null) {
      status = "Assessment";
    }
    setActiveHeader(status);

    let lastSubStatatus = null;
    try {
      lastSubStatatus = JSON.parse(localStorage.getItem("assessmentSubStatus"));
    } catch (error) {}
    if (lastSubStatatus === null && status === "Assessment") {
      lastSubStatatus = "Published";
    }
    setActiveSubHeader(lastSubStatatus);
  }, []);
  const urlParams = new URLSearchParams(window.location.search);
  const status = urlParams.get("status");
  const [activeHeader, setActiveHeader] = useState("Assessment");
  const [isAssessmentTypePopUp, setIsAssessmentTypePopUp] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);
  const [assessmentName, setAssessmentName] = useState("");
  const [open, setOpen] = useState(false);
  const [activeSubHeader, setActiveSubHeader] = useState(
    status
      ? status
      : JSON.parse(localStorage.getItem("assessmentSubStatus"))
        ? JSON.parse(localStorage.getItem("assessmentSubStatus"))
        : "Published",
  );

  const navigate = useNavigate();

  const handleClickSubButton = (s) => {
    localStorage.setItem("assessmentSubStatus", JSON.stringify(s));
    setActiveSubHeader(JSON.parse(localStorage.getItem("assessmentSubStatus")));
    setFilter((prev) => ({ ...prev, subjectId: [], date: "", time: "" }));
    //localStorage.clear();
    localStorage.removeItem("selectedDate");
    localStorage.removeItem("selectedCheckboxes");
    localStorage.removeItem("selectedDay");
  };

  const handleClickButton = (s) => {
    if (s === "Assessment") {
      setActiveSubHeader("Published");
    } else {
      setActiveSubHeader(null);
      setActiveSubHeader(
        localStorage.setItem("assessmentSubStatus", JSON.stringify(null)),
      );
    }
    localStorage.setItem("assessmentStatus", s);
    setActiveHeader(localStorage.getItem("assessmentStatus"));
    setFilter((prev) => ({ ...prev, subjectId: [], date: "", time: "" }));
    //localStorage.clear();
    localStorage.removeItem("selectedDate");
    localStorage.removeItem("selectedCheckboxes");
    localStorage.removeItem("selectedDay");
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  // useClickOutside(popupRef, () => setIsPopupOpen(false));

  //Here I added logic for toggle filter box
  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     console.log(popupRef.current.contains(event.target));
  //     if (popupRef.current && !popupRef?.current?.contains(event.target)) {
  //       setIsPopupOpen(false);
  //     }
  //   };
  //   if (isPopupOpen) {
  //     document.addEventListener("click", handleOutsideClick);
  //   }
  //   return () => {
  //     document.removeEventListener("click", handleOutsideClick);
  //   };
  // }, [isPopupOpen]);

  const handlePopupClick = (event) => {
    event.stopPropagation();
    setIsPopupOpen(!isPopupOpen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
    standard_id: "",
    section_id: "",
  });

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  const saved = JSON.parse(localStorage.getItem("temp_Questions_ASSESSMENT"));

  const handleCreate = () => {
    if (saved) {
      setAssessmentName(saved.assessmentDetails?.name);
      setHasSaved(true);
      setOpen(true);
    } else {
      setIsAssessmentTypePopUp(true);
    }
  };

  const handleContinueSaved = () => {
    setOpen(false);
    const selectedBox = localStorage.getItem("selectedBox");
    navigate("/create", {
      state: {
        selectedBox: selectedBox,
      },
    });
  };

  const handleCreateNew = () => {
    localStorage.removeItem("temp_Questions_ASSESSMENT");
    localStorage.removeItem("currentStep");
    localStorage.removeItem("selectedBox");
    setOpen(false);
    setIsAssessmentTypePopUp(true);
  };

  return (
    <div className=" h-100">
      <span className="hw_main_page_heading">Subject-wise Assessment</span>
      <div className={`${leftSidebarSize === 70 ? "expand" : "collapasess"}`}>
        <SubjBoxProps filter={filter} />
      </div>

      <div className=" me-3 main_button_box ">
        <div className="col-md-4 m-0 p-0 d-flex align-items-center justify-content-between main_button_box1">
          <button
            className={` poppins-semibold  ${
              activeHeader === "Assessment"
                ? "active main_three_button_active orange-text poppins-semibold "
                : "main_three_button "
            }`}
            onClick={(e) => {
              handleClickButton("Assessment");
              handleClickSubButton("Published");
            }}
          >
            Pending
          </button>

          <button
            className={`  poppins-semibold  ${
              activeHeader === "review"
                ? "active main_three_button_active orange-text poppins-semibold "
                : "main_three_button "
            }`}
            onClick={(e) => {
              handleClickButton("review");
            }}
          >
            On Review
          </button>

          <button
            className={`  poppins-semibold  ${
              activeHeader === "Completed"
                ? "active main_three_button_active orange-text poppins-semibold "
                : "main_three_button "
            }`}
            onClick={(e) => {
              handleClickButton("Completed");
            }}
          >
            Completed
          </button>
        </div>
        <div className="col-xl-6 col-lg-5 col-md-7 p-0 d-flex align-items-center justify-content-between tablet-layout">
          <div className="col-12 col-md-6 p-0  ">
            <input
              className="form-control mr-sm-2 m-0 name_search_box tab-margin"
              type="search"
              placeholder="Search by Assessment name"
              maxLength={50}
              aria-label="Search"
              onChange={(e) =>
                setFilter((prev) => ({ ...prev, searchvalue: e.target.value }))
              }
            ></input>
            <img
              className="name_search_icon"
              src="/images/search icon.svg"
              alt=""
            />
          </div>

          <Popup
            on="click"
            className="popup_filter_box"
            style={{ zIndex: "999" }}
            open={isPopupOpen}
            onOpen={togglePopup}
            onClose={togglePopup}
            trigger={
              <div
                className="col-md-2 col-12 gap-2  filter_button tab-margin"
                onClick={handlePopupClick}
              >
                <img
                  src="/images/filter_icon.svg"
                  alt=""
                  onClick={handlePopupClick}
                />
                <span>Filter</span>
              </div>
            }
            content={
              <div ref={popupRef}>
                <FilterBox
                  setFilter={setFilter}
                  filter={filter}
                  setIsPopupOpen={setIsPopupOpen}
                  togglePopup={togglePopup}
                />
              </div>
            }
            position="bottom center"
          />
          <div
            className=" col-md-3 col-12 gap-2 add_button tab-margin"
            onClick={() => {
              handleCreate();
              localStorage.setItem("ActiveBtn", "");
            }}
          >
            <img src="/images/add icon.svg" alt="" />
            <span>Add Assessment</span>
          </div>
        </div>
      </div>

      <div
        className="me-3 d-flex align-items-center justify-content-between mt-1"
        style={{ position: "relative" }}
      >
        <div className="col-lg-3 col-md-4 col-12 p-0 m-0 d-flex align-items-center ">
          {activeHeader === "Assessment" && (
            <>
              <button
                className={` ${
                  activeSubHeader === "Published"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  handleClickSubButton("Published");
                }}
              >
                Published
              </button>

              <button
                className={` ${
                  activeSubHeader === "Draft"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  handleClickSubButton("Draft");
                }}
              >
                Draft
              </button>
              <button
                className={` ${
                  activeSubHeader === "Scheduled"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  handleClickSubButton("Scheduled");
                }}
              >
                Scheduled
              </button>
            </>
          )}
        </div>
        <Alert
          icon={<InfoOutlinedIcon fontSize="small" />}
          severity="info"
          onClick={() => setOpenImg(true)}
          sx={{
            fontSize: "0.8rem",
            cursor: "pointer",
            width: "fit-content",
            padding: "4px 8px",
            "&:hover": {
              backgroundColor: "#e3f2fd", // hover effect
            },
          }}
        >
          Click to Know Details
        </Alert>
        <div className="m-0 mt-1 p-0 col-6 gap-2 col-md-4 d-flex align-items-center ">
          {/* Class Select */}
          <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
            <InputLabel>Select Class</InputLabel>
            <Select
              label="Select Class"
              value={filter.standard_id}
              onChange={(e) =>
                setFilter({
                  ...filter,
                  standard_id: e.target.value,
                  section_id: "",
                })
              }
            >
              <MenuItem value="">Select Class</MenuItem>
              {standardArr?.length > 0 &&
                [...standardArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>

          {/* Section Select */}
          <FormControl size="small" fullWidth sx={{ minWidth: 150, ml: 2 }}>
            <InputLabel>Select Section</InputLabel>
            <Select
              label="Select Section"
              value={filter.section_id}
              onChange={(e) =>
                setFilter({
                  ...filter,
                  section_id: e.target.value,
                })
              }
              disabled={!filter.standard_id} // Class select hone se pehle disable
            >
              <MenuItem value="">Select Section</MenuItem>
              {sectionArr &&
                sectionArr.length > 0 &&
                sectionArr
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div
        className="mt-3 me-3 button_box_conatainer orange-scrollBar"
        style={{
          maxHeight: "280px",
          overflowY: "scroll",
          paddingTop: "1em",
          paddingBottom: "1em",
        }}
      >
        {activeSubHeader === "Published" && (
          <PublishAccessBoxProps filter={filter} setFilter={setFilter} />
        )}
        {activeSubHeader === "Draft" && (
          <DraftAssessPropsBox filter={filter} setFilter={setFilter} />
        )}
        {activeSubHeader === "Scheduled" && (
          <SchedAssePropsBox filter={filter} setFilter={setFilter} />
        )}
        {activeHeader === "review" && (
          <ReviewAssePropsBox filter={filter} setFilter={setFilter} />
        )}
        {activeHeader === "Completed" && (
          <CompletAssepropsBox filter={filter} setFilter={setFilter} />
        )}
        {openImg && (
          <ImagePopupBox setOpenImg={setOpenImg} imgSrc={AssessmentImage} />
        )}
        {isAssessmentTypePopUp && (
          <AssessmentTypePopUP
            setIsAssessmentTypePopUp={setIsAssessmentTypePopUp}
          />
        )}
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        container={document.body} // ✅ force render inside body
        sx={{ zIndex: 2000 }} // ✅ 5 level higher
      >
        <DialogTitle>Unsaved Changes Found</DialogTitle>
        <DialogContent>
          <Typography>
            You already have an unsaved assessment –{" "}
            <Typography component="span" fontWeight="bold" color="primary">
              {assessmentName}
            </Typography>
            . Do you want to restore?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="error"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleContinueSaved}
            color="primary"
            variant="outlined"
          >
            Continue
          </Button>
          <Button onClick={handleCreateNew} color="primary" variant="contained">
            Ignore
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PublishedAssessment;
